import type { MockScheduleItem } from '@/data/mock';

interface ScheduleCardProps {
  items: MockScheduleItem[];
}

export function ScheduleCard({ items }: ScheduleCardProps) {
  return (
    <div className="app-card" style={{ padding: '1.25rem' }}>
      <div className="card-head" style={{ marginBottom: '0.75rem' }}>
        <h3 style={{
          fontFamily: 'var(--font-display)',
          fontWeight: 540,
          fontSize: '1.05rem',
          color: '#fff',
        }}>
          Današnji urnik
        </h3>
      </div>

      {items.map((item, i) => (
        <div key={i} style={{
          display: 'flex',
          gap: '0.85rem',
          padding: '0.7rem 0',
          borderTop: i > 0 ? '1px solid var(--app-line)' : 'none',
        }}>
          <span style={{
            fontFamily: 'var(--font-mono)',
            fontSize: '0.74rem',
            color: 'var(--copper-300)',
            flexShrink: 0,
            width: '48px',
            paddingTop: '0.1rem',
          }}>
            {item.time}
          </span>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: '0.86rem', fontWeight: 540, color: 'var(--app-strong)' }}>
              {item.title}
            </div>
            <div style={{ fontSize: '0.74rem', color: 'var(--app-muted)', marginTop: '0.1rem' }}>
              {item.loc}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
